module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('div', {
    attrs: {
      "id": "maincontainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "leftcolumn"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/')
      }
    }
  }, [_vm._v(_vm._s(_vm.appName))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "contentwrapper"
    }
  }, [_c('span', {
    staticClass: "user-display-name"
  }, [(_vm.isLoggedIn) ? _c('span', [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goTo('/UserDetails')
      }
    }
  }, [_vm._v(_vm._s(_vm.user.displayName))]), _vm._v(" "), _c('span', [_vm._v(" | ")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")])]) : _c('span', [_c('span', {
    on: {
      "click": function($event) {
        return _vm.goTo('/Login')
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('span', [_vm._v(" | ")]), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        return _vm.goTo('/Signup')
      }
    }
  }, [_vm._v("Signup")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-687762b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 527
// module chunks = 17